import React from 'react';
import type { ReportTheme } from '../../../../types/reportTheme';
import type { ReportVerdict } from '../../../../lib/reportVerdict';
import { EditorialBadge, type EditorialBadgeTone } from './EditorialBadge';

export interface EditorialVerdictMarkProps {
  theme: ReportTheme;
  verdict: ReportVerdict;
  className?: string;
  style?: React.CSSProperties;
}

export function EditorialVerdictMark({
  theme,
  verdict,
  className,
  style,
}: EditorialVerdictMarkProps): React.ReactElement {
  let tone: EditorialBadgeTone;
  switch (verdict.tier) {
    case 'green':
      tone = 'positive';
      break;
    case 'amber':
      tone = 'warning';
      break;
    case 'red':
      tone = 'negative';
      break;
    case 'none':
    default:
      tone = 'neutral';
      break;
  }

  return (
    <EditorialBadge
      theme={theme}
      tone={tone}
      variant="text"
      className={className}
      style={style}
    >
      {verdict.label}
    </EditorialBadge>
  );
}
